import BaseModel from "./BaseModel";
import {computed, makeObservable, observable} from "mobx";

export default class GameTeam extends BaseModel {
    constructor(store) {
        super(store);
        makeObservable(this, {
            id: observable,
            name: observable,
            members: observable
        })

    }
    id = 0
    name = ''
    members = []
}